export const LECTURE_SURVEY_STEP = {
    START: 0,
    RUN: 1,
    RESULT: 2,
    ADMIN: 3
};